import { render, staticRenderFns } from "./Activations.vue?vue&type=template&id=323a31d5"
import script from "./Activations.vue?vue&type=script&lang=js"
export * from "./Activations.vue?vue&type=script&lang=js"
import style0 from "../../assets/style/shop.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports